export enum SettingMainItemsKeys {
  AppConfiguration = 'App Configuration',
  PresentationDisplay = 'Presentation display',
  MouseAnimation = 'Mouse Animation',
  BrowserSettings = 'Browser Settings',
}
